import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { btnRegExp } from "./constants";

const WayForPayWidget: React.FC<{ htmlContent: string }> = ({
  htmlContent,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || !htmlContent) return;

    const temp = document.createElement("div");
    temp.innerHTML = htmlContent;

    const scriptElement = temp.querySelector("#widget-wfp-script");
    if (scriptElement) {
      const newScript = document.createElement("script");
      newScript.src = scriptElement.getAttribute("src") || "";
      newScript.id = "widget-wfp-script";
      newScript.onload = () => {
        const paymentScript = temp.querySelector("script:not([src])");
        if (paymentScript) {
          const newPaymentScript = document.createElement("script");
          newPaymentScript.textContent = paymentScript.textContent;
          containerRef.current?.appendChild(newPaymentScript);
        }
      };
      containerRef.current.appendChild(newScript);
    }

    const messages = ["approvedMessage", "declinedMessage", "pendingMessage"];
    messages.forEach((id) => {
      const messageDiv = temp.querySelector(`#${id}`);
      if (messageDiv) {
        const clonedDiv = messageDiv.cloneNode(true) as HTMLElement;
        clonedDiv.style.setProperty("display", "none", "important");
        containerRef.current?.appendChild(clonedDiv);
      }
    });

    const styleTag = document.createElement("style");
    styleTag.textContent = `
      #approvedMessage, #declinedMessage, #pendingMessage {
        display: none !important;
      }
    `;
    containerRef.current?.appendChild(styleTag);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [htmlContent]);

  const cleanHtmlContent = htmlContent.replace(btnRegExp, "");

  return (
    <Box
      ref={containerRef}
      dangerouslySetInnerHTML={{ __html: cleanHtmlContent }}
    />
  );
};

export default WayForPayWidget;
